module.exports = __webpack_public_path__ + "img/吹泡泡的小孩.77233cab.png";